import { db } from './config';
import { collection, getDocs, doc, getDoc, addDoc, updateDoc, deleteDoc } from 'firebase/firestore';

const DOCTORS_COLLECTION = 'doctors';

// Get all doctors
export const getDoctors = async () => {
  try {
    const doctorsCollection = collection(db, DOCTORS_COLLECTION);
    const doctorSnapshot = await getDocs(doctorsCollection);
    const doctorList = doctorSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    
    // Sort by order field, then by creation order if no order field exists
    return doctorList.sort((a, b) => {
      const orderA = a.order !== undefined ? a.order : 999;
      const orderB = b.order !== undefined ? b.order : 999;
      return orderA - orderB;
    });
  } catch (error) {
    console.error('Error retrieving doctors:', error);
    throw error;
  }
};

// Get a single doctor by ID
export const getDoctor = async (id) => {
  try {
    const doctorDoc = doc(db, DOCTORS_COLLECTION, id);
    const doctorSnapshot = await getDoc(doctorDoc);
    
    if (doctorSnapshot.exists()) {
      return {
        id: doctorSnapshot.id,
        ...doctorSnapshot.data()
      };
    } else {
      throw new Error('Doctor not found');
    }
  } catch (error) {
    console.error('Error getting doctor:', error);
    throw error;
  }
};

// Add a new doctor
export const addDoctor = async (doctorData) => {
  try {
    // Use local placeholder image if no image is provided
    if (!doctorData.image) {
      doctorData.image = '/images/placeholder-doctor.svg';
    }
    
    const docRef = await addDoc(collection(db, DOCTORS_COLLECTION), doctorData);
    return {
      id: docRef.id,
      ...doctorData
    };
  } catch (error) {
    console.error('Error adding doctor:', error);
    throw error;
  }
};

// Update an existing doctor
export const updateDoctor = async (id, doctorData) => {
  try {
    // Use local placeholder image if no image is provided
    if (!doctorData.image) {
      doctorData.image = '/images/placeholder-doctor.svg';
    }
    
    const doctorRef = doc(db, DOCTORS_COLLECTION, id);
    await updateDoc(doctorRef, doctorData);
    return {
      id,
      ...doctorData
    };
  } catch (error) {
    console.error('Error updating doctor:', error);
    throw error;
  }
};

// Delete a doctor
export const deleteDoctor = async (id) => {
  try {
    console.log('doctorService: Attempting to delete document with ID:', id);
    if (!id) {
      throw new Error('No ID provided for deletion');
    }
    const doctorRef = doc(db, DOCTORS_COLLECTION, id);
    await deleteDoc(doctorRef);
    console.log('doctorService: Successfully deleted document:', id);
    return true;
  } catch (error) {
    console.error('doctorService: Error deleting doctor:', error);
    throw error;
  }
};